import { utils, writeFileXLSX } from 'xlsx';

export const downloadJSONAsXLSX = (fileName: string, data: any[]) => {
    const ws = utils.json_to_sheet(data);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    writeFileXLSX(wb, fileName + ".xlsx");
}